import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';

import { getExternalAppId, setTokenWithMeWithExpirationDate, setTown, setUser } from '../../_core/utilities/localstorage.util';
import { TokenWithMeDTO } from '../dto/token-with-me.dto';
import { Me } from '../types/me.class';
import { TokenWithMe } from '../types/token-with-me.class';
import { GlobalService } from './_global.service';


@Injectable({ providedIn: 'root' })
export class AuthenticationService extends GlobalService {

    public getMe(): Observable<Me | null> {
        return new Observable((sub: Subscriber<Me | null>) => {
            if (getExternalAppId()) {
                this.getToken().subscribe({
                    next: (token: TokenWithMe) => {
                        sub.next(token.simple_me);
                    },
                    error: (err: HttpErrorResponse) => {
                        sub.error(err);
                    }
                });
            } else {
                setUser(null);
                setTown(null);
                sub.next(null);
            }
        });
    }

    /**
     * @param {boolean} [silent] Ne remonte aucun message à l'utilisateur si la clef est refusée
     */
    public getToken(silent?: boolean): Observable<TokenWithMe> {
        return new Observable((sub: Subscriber<TokenWithMe>) => {
            super.get<TokenWithMeDTO>(this.API_URL + `/Authentication/Token?userKey=${getExternalAppId()}`, undefined, undefined, silent)
                .subscribe({
                    next: (response: HttpResponse<TokenWithMeDTO>) => {
                        const token_with_me: TokenWithMe = new TokenWithMe(response.body);
                        setUser(token_with_me.simple_me);
                        setTown(token_with_me.simple_me.town_details);
                        setTokenWithMeWithExpirationDate(token_with_me);
                        sub.next(token_with_me);
                    },
                    error: (error: HttpErrorResponse) => {
                        sub.error(error);
                    }
                });
        });
    }
}

